var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 375,
    viewBox: "0 0 375 375",
    height: 375,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0074B5",
    d: "M 372.070312 279.625 C 372.070312 330.515625 330.507812 372.070312 279.636719 372.070312 L 95.375 372.070312 C 44.484375 372.070312 2.929688 330.515625 2.929688 279.625 L 2.929688 95.371094 C 2.929688 44.488281 44.484375 2.929688 95.375 2.929688 L 279.636719 2.929688 C 330.507812 2.929688 372.070312 44.488281 372.070312 95.371094 Z M 372.070312 279.625"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M 73.242188 149.414062 L 125.976562 149.414062 L 125.976562 301.757812 L 73.242188 301.757812 Z M 73.242188 149.414062"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M 99.207031 126.078125 C 114.027344 126.078125 126.085938 114.039062 126.085938 99.210938 C 126.085938 84.367188 114.027344 72.335938 99.207031 72.335938 C 84.355469 72.335938 72.335938 84.367188 72.335938 99.210938 C 72.335938 114.039062 84.355469 126.078125 99.207031 126.078125"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M 301.757812 218.277344 C 301.757812 176.835938 293.273438 149.148438 244.972656 149.148438 C 221.757812 149.148438 206.640625 158.203125 200.257812 169.921875 L 199.21875 169.921875 L 199.21875 149.414062 L 158.203125 149.414062 L 158.203125 301.757812 L 202.148438 301.757812 L 202.148438 226.550781 C 202.148438 206.484375 206.242188 187.050781 231.074219 187.050781 C 255.527344 187.050781 257.8125 209.996094 257.8125 227.839844 L 257.8125 301.757812 L 301.757812 301.757812 Z M 301.757812 218.277344"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(2.92969 0 0 2.92969 0 0)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 95.441338 1 L 32.546667 1 C 15.182666 1 0.999999 15.182668 0.999999 32.553335 L 0.999999 95.445339 C 0.999999 112.812007 15.182666 127.000008 32.546667 127.000008 L 95.441338 127.000008 C 112.812005 127.000008 127.000006 112.812007 127.000006 95.445339 L 127.000006 32.553335 C 127.000006 15.182668 112.812005 1 95.441338 1 Z M 95.441338 1",
    stroke: "#333",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(2.92969 0 0 2.92969 0 0)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 93.000004 7 L 34.769334 7 C 19.617333 7 6.999999 19.616001 6.999999 34.769335 L 6.999999 93.229339 C 6.999999 108.38134 19.617333 121.000007 34.769334 121.000007 L 93.229338 121.000007 C 108.381338 121.000007 121.000006 108.38134 121.000006 93.229339 L 121.000006 65.000004",
    stroke: "#333",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(2.92969 0 0 2.92969 0 0)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 93.000004 7 C 100.576005 7 107.665338 10.401334 112.630672 15.368001",
    stroke: "#333",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(2.92969 0 0 2.92969 0 0)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 121.000006 58.000004 L 121.000006 43.000003",
    stroke: "#333",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(2.92969 0 0 2.92969 0 0)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 43.000001 103.000006 L 25 103.000006 L 25 51.000003 L 43.000001 51.000003 Z M 43.037334 33.864002 C 43.037334 38.925336 38.921334 43.034669 33.862667 43.034669 C 28.793334 43.034669 24.690667 38.925336 24.690667 33.864002 C 24.690667 28.797335 28.793334 24.692002 33.862667 24.692002 M 103.000005 75.000005 L 103.000005 103.000006 L 88.000004 103.000006 L 88.000004 77.769338 C 88.000004 71.678671 87.220004 63.846671 78.873337 63.846671 C 70.397336 63.846671 69.000003 70.480004 69.000003 77.330671 L 69.000003 103.000006 L 54.000002 103.000006 L 54.000002 51.000003 L 68.000003 51.000003 L 68.000003 58.000004 L 68.354669 58.000004 C 70.533336 54.000003 75.693336 51.157336 83.61867 51.157336",
    stroke: "#333",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLk);
export default __webpack_public_path__ + "static/media/lk.c4c57c35b5b2beeecdbac8e953825591.svg";
export { ForwardRef as ReactComponent };